<script lang="ts">
    import {createEventDispatcher, onMount} from "svelte";
    import {UrlUtil} from "../../../lib/Common/Http/UrlUtil";
    import {HttpRequestUtil} from "../../../lib/Common/Http/HttpRequestUtil";
    import DialogView from "../../../component/common/Dialog/DialogView.svelte";
    import LoadingContentView from "../../../component/common/Loading/LoadingContentView.svelte";
    import PortalView from "../../../component/common/Portal/PortalView.svelte";
    import SpaceAuthorityUserView from "./SpaceAuthorityUserView.svelte";
    import SpaceAuthorityCompanyDepartmentView from "./SpaceAuthorityCompanyDepartmentView.svelte";
    import {DialogViewUtil} from "../../common/Dialog/DialogViewUtil";
    import SpaceAuthorityTypeView from "./SpaceAuthorityTypeView.svelte";

    const dispatcher = createEventDispatcher();

    export let spaceId;
    export let isShow = false;

    $: dialogTitle = (() => {
        if (space == null) {
            return '';
        }
        const dialogTitle = `${space.name} のスペースは誰に公開されていますか？`;
        return dialogTitle;
    })();

    $: authorityDescriptionArray = (() => {
        if (space == null) {
            return [];
        }
        const authorityDescriptionArray = [];
        if (space.is_public === 1) {
            if (space.can_employee_only === 1) {
                authorityDescriptionArray.push('公開スペースです。権限設定していない社員以上のみアクセスができます');
            } else {
                authorityDescriptionArray.push('公開スペースです。権限設定していない人でもアクセスができます');
            }
        } else {
            authorityDescriptionArray.push('権限を持った人しかアクセスできません');
        }
        if (space.can_employee_only === 1) {
            authorityDescriptionArray.push('社員以上のみに公開制限されています。業務委託、派遣社員の方は閲覧できません。');
        }
        return authorityDescriptionArray;
    })();


    let space = null;
    let isLoading = false;

    onMount(() => {

    });

    function loadData() {
        const paramMap = {};
        paramMap['id'] = spaceId;
        paramMap['include_space_users'] = undefined;
        paramMap['include_space_user_user'] = undefined;
        paramMap['include_space_company_departments'] = undefined;
        const url = UrlUtil.createApiUrl("space", paramMap);

        isLoading = true;
        HttpRequestUtil.getRequest(url, (response) => {
            isLoading = false;
            console.log(response);
            const body = response['body'];
            const spaces = body['spaces'];

            if (spaces.length > 0) {
                space = spaces[0];
            } else {
                space = null;
            }


        });

    }

    function onShow() {
        loadData();
    }

    function onClose() {
        dispatcher('close');
    }

</script>

<div class="space-authority-check-dialog-view">
    <PortalView>
        <DialogView on:show={onShow} isShow={isShow} on:close={onClose}
                    title={dialogTitle}
                    footerType={DialogViewUtil.FooterType.OkButton}
        >
            <div class="space-authority-check-content">
                <LoadingContentView isLoading={isLoading}>
                    {#if space != null}
                        <div class="space-area">
                            <div class="authority-area">
                                <fieldset>
                                    <legend>権限設定</legend>

                                    <SpaceAuthorityTypeView space={space}/>

                                    <div class="authority-description-area">
                                        {#each authorityDescriptionArray as authorityDescription}
                                            <div>
                                                {authorityDescription}
                                            </div>
                                        {/each}
                                    </div>

                                    <div class="authority-list-area">
                                        <SpaceAuthorityCompanyDepartmentView
                                                spaceCompanyDepartments={space.space_company_departments}/>

                                        <SpaceAuthorityUserView spaceUsers={space.space_users}/>


                                    </div>
                                </fieldset>
                            </div>

                            <!--                            <div class="space-ip-area">-->
                            <!--                                <AccessIpAreaView spaceId={space.id}/>-->
                            <!--                            </div>-->

                        </div>
                    {/if}

                </LoadingContentView>

            </div>
        </DialogView>

    </PortalView>


</div>
<style lang="scss">


    .space-authority-check-content {
        min-width: 620px;

        .space-area {
            display: flex;
            gap: 60px;

            .authority-area {
                width: 45vw;

                .authority-description-area {

                }

                .authority-list-area {

                    .space-company-department-area {
                        margin-top: 30px;

                        > .title {
                            opacity: 0.5;
                            font-size: 0.7em;
                        }

                        .space-company-departments {
                            margin-top: 8px;

                            .space-company-department {


                            }
                        }
                    }

                    .space-user-area {
                        margin-top: 30px;

                        > .title {
                            opacity: 0.5;
                            font-size: 0.7em;
                        }

                        table {
                            margin-top: 8px;
                            font-size: 0.7em;

                            thead {

                            }

                            tbody {

                            }
                        }
                    }
                }
            }


            .space-ip-area {
                width: 45vw;
            }

        }

    }
</style>